import * as yup from "yup";

export const validations = yup.object({
  partners_segment: yup.string().required("Este campo é obrigatório"),
  product_portfolio: yup.string().required("Este campo é obrigatório"),
  partners_segment_portfolio: yup.string().required("Este campo é obrigatório"),
  client_employees: yup.string().required("Este campo é obrigatório"),
  partners_reason: yup.string().required("Este campo é obrigatório"),
});
